export default "__VITE_ASSET__DUlRWm6c__"